function getYoutubeId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  return match && match[2].length === 11 ? match[2] : null
}
export const getYoutubeEmbedLink = url => `https://youtube.com/embed/${getYoutubeId(url)}`

export const getVimeoEmbedLink = url => url.replace('//vimeo.com', '//player.vimeo.com/video')

const embeddedLinkGenerators = {
  youtube: getYoutubeEmbedLink,
  vimeo: getVimeoEmbedLink
}

export default embeddedLinkGenerators
